// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"0629ec7d","626":"e46b5f62"}[chunkId] + ".chunk.js";
};